module.exports = "pegasus/assets/active-row-border-right.png";